import { createApp } from 'vue'
import { createI18n } from 'vue-i18n';
import App from './App.vue'
import router from './router'
import AOS from 'aos'
import { createHead } from '@vueuse/head'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import './assets/styles/global.scss'
import 'mdb-vue-ui-kit/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'vueperslides/dist/vueperslides.css';
import 'aos/dist/aos.css'

import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';
AOS.init();

// Langue
let savedLang = localStorage.getItem('site-language')
if (!savedLang) {
  const browserLang = navigator.language || navigator.userLanguage
  savedLang = browserLang.split('-')[0]
}
if (!['fr', 'en', 'de'].includes(savedLang)) {
  savedLang = 'en'
}

// Création d'une instance i18n pour Vue 3
const i18n = createI18n({
  legacy: false, // <-- IMPORTANT : utilise la Composition API
   globalInjection: true,
   locale: savedLang,
   fallbackLocale: 'en', //vérifie que la langue est disponible dans mes locales et sinon on met le site en anglais
   messages: { fr, en, de },

});

const app = createApp(App)
const head = createHead()

app.component('font-awesome-icon', FontAwesomeIcon)

app.use(head);
app.use(router);
app.use(i18n);

app.mount('#app');


